import sharedStyles from 'typescript/components/select_and_reveal/shared_styles.module.scss';

export const CARD_HEIGHT = Number.parseInt(sharedStyles.cardHeight, 10);
export const CARD_GAP = Number.parseInt(sharedStyles.cardGap, 10);
export const TRANSITION_TIME = Number.parseInt(sharedStyles.transitionTime, 10);
